
    module.exports = Object.keys || function(obj) {
        if (obj !== Object(obj)) throw new TypeError('Invalid object');
        var keys = [];
        for (var key in obj) if (exports.has(obj, key)) keys.push(key);
        return keys;
    };




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/internals/keys.js
// module id = 4574
// module chunks = 15